import MobileVersion from './MobileVersion';
import DeviceHelper, { Device } from '../Core/DeviceHelper';
import Hotjar from '../Modules/Hotjar';

const hotjar = new Hotjar();
const mobileVersion = new MobileVersion();

var Sharing = {
    Initialize() {
        var $container = document.getElementsByClassName('header__titulo__share');
        if (!$container || $container.length === 0)
            return;

        const $buttonFB = document.getElementById('share-fb');
        const $buttonTW = document.getElementById('share-tw');
        const $buttonWSP = document.getElementById('share-wsp');
        const $buttonComment = document.getElementById('comment');

        $buttonFB.addEventListener('click', function (e) {
            e.preventDefault();
            shareFacebook();
            hotjar.tagRecording(['compartir', 'facebook']);
        });

        $buttonTW.addEventListener('click', function (e) {
            e.preventDefault();

            var titulo = $(e.target).data('title');
            shareTwitter(titulo);
            hotjar.tagRecording(['compartir', 'twitter']);
        });

        $buttonWSP.addEventListener('click', function (e) {
            e.preventDefault();

            var titulo = $(e.target).data('title');
            shareWhatsapp(titulo);
            hotjar.tagRecording(['compartir', 'whatsapp']);
        });

        if ($buttonComment) {
            $buttonComment.addEventListener('click', e => {
                e.preventDefault();

                document.getElementById("comunidad").scrollIntoView({ behavior: "smooth" });
                hotjar.tagRecording('comentar');
            });
        }

        // Init FB
        FB && FB.init({
            appId: window.config.Statics.FacebookId,
            autoLogAppEvents: true,
            xfbml: true,
            version: 'v2.11'
        });
        FB && FB.AppEvents.logPageView();
    }
};

function isDesktop() {
    var device = DeviceHelper.GetDevice();
    return device == Device.Desktop;
}

function shareFacebook() {
    if (mobileVersion.isMobile()) {
        mobileVersion.SendEventMobile('FACEBOOK', location.href);
    } else {
        FB && FB.ui({
            method: 'share',
            mobile_iframe: true,
            href: `${location.href}`
        }, function (response) { });
    }
}

function shareTwitter(titulo) {
    var url = `//twitter.com/share?text=${titulo}&url=${location.href}&via=LANACION`;
    if (mobileVersion.isMobile()) {
        mobileVersion.SendEventMobile('TWITTER', location.href);
    } else {
        openUrl(url);
    }
}

function shareWhatsapp(titulo) {
    const texto = titulo ? `${titulo} - Cartelera LA NACION: ${location.href}` : `Cartelera LA NACION: ${location.href}`;
    if (isDesktop()) {
        var urlShare = `https://api.whatsapp.com/send?text=${texto}`;
        open(urlShare, '_blank');
    } else {
        if (mobileVersion.isMobile()) {
            mobileVersion.SendEventMobile('WHATSAPP', texto);
        } else {
            var wspShare = `intent://send?text=${texto}#Intent;scheme=whatsapp;package=com.whatsapp;end`;
            location.href = wspShare;
        }
    }
}

function openUrl(url) {
    open(url, '', 'top=300,left=550,width=800,height=380');
}

export default Sharing;


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/Sharing.js